/**
 * DeMark Pivot Points
 *
 * Tom DeMark's pivot system where the pivot formula changes
 * depending on the relationship between open and close.
 *
 * Category: Support/Resistance | Pane: Overlay
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const demarkPivotIndicator: IndicatorDefinition = {
  id: "demark_pivot",
  name: "DeMark Pivot Points",
  shortName: "DM-PVT",
  category: "support_resistance",
  pane: "overlay",
  params: [],
  plots: [
    { key: "pp", label: "PP", color: "#FF9800", style: "line", lineWidth: 2 },
    { key: "r1", label: "R1", color: "#F44336", style: "line", lineWidth: 1 },
    { key: "s1", label: "S1", color: "#4CAF50", style: "line", lineWidth: 1 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    if (candles.length < 2) return ["pp","r1","s1"].map(k => ({ key: k, data: [] }));

    const prev = candles[candles.length - 2];
    let x: number;
    if (prev.close < prev.open) {
      x = prev.high + 2 * prev.low + prev.close;
    } else if (prev.close > prev.open) {
      x = 2 * prev.high + prev.low + prev.close;
    } else {
      x = prev.high + prev.low + 2 * prev.close;
    }

    const pp = x / 4;
    const r1 = x / 2 - prev.low;
    const s1 = x / 2 - prev.high;

    const makeLine = (val: number) => candles.map(c => ({ time: c.time, value: val }));
    return [
      { key: "pp", data: makeLine(pp) },
      { key: "r1", data: makeLine(r1) },
      { key: "s1", data: makeLine(s1) },
    ];
  },
};
